import {useState} from 'react';
import {I18n} from 'aws-amplify/utils';
import {FlexiAddButton} from '@flexinet/ui-components';

import {RecordFormDrawer} from '../drawers/RecordFormDrawer';
import {useRecordWriteCapabilities} from '../hooks/useRecordWriteCapabilities';

// FNP-1192 — the Add control, and the hiding rule it obeys.
//
// ⚠️ HIDDEN, NOT DISABLED, when the connection cannot write records.
//
// A disabled button promises a capability that does not exist and invites the
// operator to go hunting for the permission that would enable it. An absent one
// is a correct statement about a read-only connection. And the default is
// "hidden" in every UNKNOWN case too — loading, errored, no connection, not
// ACTIVE, no snapshot — because a control that appears optimistically and then
// fails at submit tells a tenant their credential is broken when the truth is
// that Flexi should never have offered the action.
export const AddRecordButton = (
    {
        connectionId,
        zoneId,
    }: {
        connectionId?: string,
        zoneId?: string,
    },
) => {

    const [opened, setOpened] = useState(false);

    const {canWriteRecords} = useRecordWriteCapabilities(connectionId);

    if (!canWriteRecords) {
        return null;
    }

    return (
        <>
            <FlexiAddButton onClick={() => setOpened(true)}>
                {I18n.get('Add Record')}
            </FlexiAddButton>
            <RecordFormDrawer
                connectionId={connectionId}
                zoneId={zoneId}
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
